import { IUntypedQuery, Topics } from '@zaplify/common';

export class MatchCompanyNameQuery extends IUntypedQuery {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly name: string) {
        super();
    }
}
